import RegisterEmailCheck from "../../../../../modules/Login/components/RegisterEmailCheck";
import { useCallback } from "react";
import { closeMobileSliderPageAction, registrationStartMobileAction } from "../../../../mobileAppActions";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getRegistrationData } from "../../../../../app/appSelectors";
import {
    SlideMobileRegisterEmailCheckCloseButtonContainerStyled,
    SlideMobileRegisterEmailCheckStyled
} from "./styled/SlideMobileRegisterEmailCheckStyled";
import MobileSliderPagesCloseButton from "../../components/MobileSliderPagesCloseButton";
import { logAppsflyerAction } from "../../../../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../../../../app/appConstants";

function SlideMobileRegisterEmailCheck(props) {
    const {closeMobileSliderPage, logAppsflyer, registerData, registrationStart} = props;

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        registrationStart({
            email: e.target.querySelector('[name=email]').value,
            phone: registerData?.phone,
            country: registerData?.country,
            password: registerData?.password,
        });
        logAppsflyer({ name: LOG_AF_EVENT_NAMES.SIGN_UP_EMAIL_IS_CORRECT });
    }, [logAppsflyer, registerData, registrationStart]);

    const handleCrossButtonClick = useCallback(() => {
        logAppsflyer({
            name: LOG_AF_EVENT_NAMES.SIGN_UP_EMAIL_IS_CORRECT_CANCEL,
            payload: { button: 'cross_button' },
        });
    }, [logAppsflyer]);

    const handleBackButtonClick = useCallback(() => {
        logAppsflyer({
            name: LOG_AF_EVENT_NAMES.SIGN_UP_EMAIL_IS_CORRECT_CANCEL,
            payload: { button: 'back_button' },
        });
        closeMobileSliderPage();
    }, [closeMobileSliderPage, logAppsflyer]);

    return <SlideMobileRegisterEmailCheckStyled>
        <SlideMobileRegisterEmailCheckCloseButtonContainerStyled>
            <MobileSliderPagesCloseButton onClick={handleCrossButtonClick}/>
        </SlideMobileRegisterEmailCheckCloseButtonContainerStyled>
        <RegisterEmailCheck onSubmit={handleSubmit} onClose={handleBackButtonClick}/>
    </SlideMobileRegisterEmailCheckStyled>
}

const mapStateToProps = createStructuredSelector({
    registerData: getRegistrationData,
});

const mapDispatchToProps = (dispatch) => ({
    closeMobileSliderPage: payload => dispatch(closeMobileSliderPageAction(payload)),
    logAppsflyer: payload => dispatch(logAppsflyerAction(payload)),
    registrationStart: payload => dispatch(registrationStartMobileAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SlideMobileRegisterEmailCheck);
